import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import ChartContainer from "../../../../../../app/common-components/ChartContainer";
import Spinners from "../../../../../../app/common-components/Spinner";
import CatagorizedContainer from "./catagoryContanier";
import "./styles.css";
import Uncategorised from "./uncatagorizedContanier";
import { CATEGORY_TYPES } from "./Utilities/Identifiers";

const JiraStatus = (props) => {
  const activeTab = props.activeTab;
  const { StatusCatagorizedData, StatusConfigJiraListLoading } = useSelector(
    (state) => state.toolsApi
  );
  const StatusData = Array.isArray(StatusCatagorizedData)
    ? StatusCatagorizedData
    : [];

  const categorizedData = StatusData.filter(
    (item) => item.categoryName !== CATEGORY_TYPES.UNCATEGORIZED
  ).sort((a, b) => a.priorityOrder - b.priorityOrder);

  const uncategorizedData = StatusData.find(
    (item) => item?.categoryName === CATEGORY_TYPES.UNCATEGORIZED
  );

  const StatusUnCategorized = uncategorizedData?.statusType?.length
    ? [
        {
          key: "uncategorized",
          data: uncategorizedData?.statusType,
          itemCount: uncategorizedData?.statusType?.length,
          chart: (props) => (
            <Uncategorised
              list={uncategorizedData?.statusType}
              count={uncategorizedData?.statusType?.length}
              {...props}
            />
          ),
          navContainerClass: "flowdisnav",
          chartContainerClass: "flowdistribution svg-container",
          customClass:
            "col-lg-12 col-md-12 order-md-6 order-lg-5 filtercol filetotal jiraUncatagorized",
        },
      ]
    : [];

  const StatusCategorized = categorizedData.map((category) => ({
    key: category.configId ?? category.categoryName,
    chart: (props) => (
      <CatagorizedContainer
        title={category?.categoryName}
        order={category?.priorityOrder}
        data={Array.isArray(category?.statusType) ? category?.statusType : []}
        itemCount={
          Array.isArray(category?.statusType) ? category?.statusType?.length : 0
        }
        activeTab={activeTab}
        {...props}
      />
    ),
    navContainerClass: "flowdisnav",
    chartContainerClass: "flowdistribution svg-container",
    customClass:
      "col-lg-12 col-md-12 order-md-6 order-lg-5 filtercol filetotal jiraCategorized",
  }));

  return (
    <>
      {StatusConfigJiraListLoading ? (
        <Spinners />
      ) : (
        <>
          {StatusUnCategorized.map((type) => (
            <ChartContainer key={type.key} {...type}>
              {type.chart()}
            </ChartContainer>
          ))}
          {StatusCategorized.map((type) => (
            <ChartContainer key={type.key} {...type}>
              {type.chart()}
            </ChartContainer>
          ))}
        </>
      )}
    </>
  );
};

JiraStatus.propTypes = {
  activeTab: PropTypes.string.isRequired,
};

export default JiraStatus;
